// Pure gates for the account-menu entries, kept out of sidebar.tsx so they can be unit tested.

export interface SidebarAudience {
  /** The current user owns the current workspace. */
  isWorkSpaceOwner: boolean;
  /** The current user is an owner or member of the current workspace. */
  isMemberOrOwner: boolean;
  /** Support mode (?supportedUserId) — the sidebar is read-only. */
  readOnly?: boolean;
}

/** "Credits & usage" is a read-only view: every workspace member sees it; buying stays owner-only. */
export const canSeeCreditsUsage = ({ isWorkSpaceOwner, isMemberOrOwner, readOnly }: SidebarAudience): boolean =>
  !readOnly && (isWorkSpaceOwner || isMemberOrOwner);
